module.exports = __webpack_public_path__ + "static/manta-equipment-logo.550cd6a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manta-equipment-logo.png
// module id = 670
// module chunks = 114276838955818